/**
 * Utility for checking user permissions against the Redux store state.
 *
 * @module utils/permissionCheck
 * @author Snowfly
 * @version 1.0.0
 */
import store from '../redux/store';

/**
 * Checks whether a specific task has the required permissions based on the
 * provided type.
 *
 * This function verifies user permissions against the currently stored state.
 * Permissions are analyzed depending on whether the type is 'view' or a
 * specific permission type.
 *
 * @param {string} task - The name of the task to check permissions for.
 * @param {string} type - The type of permission to check (e.g., 'view', 'edit', etc.).
 * @returns {boolean} - Returns true if the user has the required permissions
 * for the task, false otherwise.
 */
export const permissionCheck = (task, type) => {
    // fetch current state
    const state = store.getState();
    let permitted;
    const {permissions} = state?.login?.user ?? state.login ?? [];
    let accessPermission = 0;
    if (permissions && permissions.length) {
        // eslint-disable-next-line array-callback-return
        permissions.map((permission) => {
            if (type === 'view') {
                const sameTaskArray = permission.permission_details.filter(
                    (ele) => ele.task_name === task,
                );
                const firstType = sameTaskArray[0] ?
                    sameTaskArray[0].permission_type :
                    null;
                const secondType = sameTaskArray[1] ?
                    sameTaskArray[1].permission_type :
                    null;
                const thirdType = sameTaskArray[2] ?
                    sameTaskArray[2].permission_type :
                    null;
                const fourthType = sameTaskArray[3] ?
                    sameTaskArray[3].permission_type :
                    null;
                permitted = permission.permission_details.some(
                    (ele) => {
                        const hasFirst = (ele.permission_type === firstType),
                            hasSecond = (ele.permission_type === secondType),
                            hasThird = (ele.permission_type === thirdType),
                            hasFourth = (ele.permission_type === fourthType);

                        return hasFirst || hasSecond || hasThird || hasFourth;
                    },
                );

                if (permitted) {
                    accessPermission += 1;
                }
            } else {
                permitted = permission.permission_details.some((ele) => {
                    return (ele.task_name === task)&& (ele.permission_type === type);
                });
                if (permitted) {
                    accessPermission += 1;
                }
            }
        });
    }

    return accessPermission > 0;
};

export default permissionCheck;
